import React, { useState, useEffect } from 'react';
import './LocationInput.css';

export default function LocationInput({ locationName, onLocationChange, apiKey }) {
  const [inputText, setInputText] = useState(locationName);
  const [isGeocoding, setIsGeocoding] = useState(false);
  const [geoError, setGeoError] = useState(null);

  // Sync input when parent-provided name changes (e.g. reverse-geocoded on load)
  useEffect(() => {
    setInputText(locationName);
  }, [locationName]);

  const geocode = async () => {
    const text = inputText.trim();
    if (!text) return;
    setIsGeocoding(true);
    setGeoError(null);
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json` +
        `?address=${encodeURIComponent(text)}&key=${apiKey}`
      );
      const data = await res.json();
      if (data.status === 'OK' && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        const name = data.results[0].formatted_address;
        onLocationChange({ lat, lng, name });
        setInputText(name);
      } else {
        setGeoError('Location not found. Try a different address.');
      }
    } catch (err) {
      console.error('Geocoding error:', err);
      setGeoError('Could not reach geocoding service.');
    } finally {
      setIsGeocoding(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') geocode();
  };

  return (
    <div className="location-input-wrapper">
      <div className="location-input-bar">
        <input
          className="location-input__field"
          type="text"
          value={inputText}
          onChange={e => { setInputText(e.target.value); setGeoError(null); }}
          onKeyDown={handleKeyDown}
          placeholder="Enter a location..."
          disabled={isGeocoding}
          aria-label="Search location"
        />
        <button
          className="location-input__button"
          onClick={geocode}
          disabled={isGeocoding}
          aria-label="Set location"
        >
          {isGeocoding ? '…' : '→'}
        </button>
      </div>
      {geoError && <p className="location-error">{geoError}</p>}
    </div>
  );
}
